import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Input, Spinner } from "reactstrap";
import { useDispatch } from "react-redux";
import { login } from "../../../actions/customer";
import { CustomSnackbar } from "../../../helpers/CustomSnackbar";
import PasswordInput from "../../../helpers/Common/PasswordInput";
import {
  isEmailVerified,
  isMobileVerified,
  redirect_url_key,
  detectLoginMethod,
  last_logged_in_username_key,
} from "../../../helpers/common";
import VerifyEmailAndMobileModal from "./VerifyEmailAndMobileModal";

const SignInForm = ({ formData, setFormData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [userData, setUserData] = useState(null);

  const [searchParams] = useSearchParams();

  // `/signup?isInternal=true` this url is for our internal members to create new accounts and to bypass the email verification step.
  const isInternal = searchParams.get("isInternal");

  // useEffect(() => {
  //   const username = localStorage.getItem(last_logged_in_username_key);

  //   if (username) {
  //     setFormData((prev) => ({ ...prev, username }));
  //   }
  // }, [setFormData]);

  const onValueChange = (e, name) => {
    setFormData({ ...formData, [name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!formData?.username) {
      CustomSnackbar.warning("Please enter your email or mobile number");
      return;
    }

    const loginMethod = detectLoginMethod(formData?.username);
    if (!loginMethod) {
      CustomSnackbar.warning(
        "Please enter a valid email address or mobile number",
      );
      return;
    }

    if (formData?.password?.length < 8) {
      CustomSnackbar.warning("Password should be at least 8 characters");
      return;
    }

    // Store username for last logged in (both email and mobile)
    localStorage.setItem(last_logged_in_username_key, formData?.username);
    localStorage.setItem("customer_type", formData.customerType);
    localStorage.setItem("jobseekerspage_userId", formData.userId);
    const redirect_url = localStorage.getItem(redirect_url_key);

    setIsLoading(true);

    // Prepare login payload with detected method
    const loginPayload = {
      email: formData?.username,
      password: formData?.password,
      login_method: loginMethod,
      customerType: formData?.customerType,
    };

    // --- Is section ko replace karein ---
    dispatch(login(loginPayload, isInternal)).then((res) => {
      setIsLoading(false);

      console.log("FULL RES:", res);

      // Extracting data from the nested response
      const loginData = res?.data?.data;
      const token = loginData?.token;
      const userId = loginData?.userId;
      const serverCustomerType = loginData?.customerType; // Get role from Server
      const userInfo = res?.data;

      console.log("--- LOGIN DATA CHECK ---");
      console.log("Token exists:", !!token);
      console.log("User ID from Server:", userId);
      console.log("Login Data:", loginData);
      console.log("Customer Type:", loginData?.customerType);
      console.log("Role:", loginData?.role);
      console.log("Type of customerType:", typeof loginData?.customerType);
      console.log("Role from Server:", loginData?.role);
      console.log("------------------------");

      if (token) {
        // ✅ FIXED KEY HERE
        localStorage.setItem("webvi_userInfo", JSON.stringify(userInfo)); // Added JSON.stringify for safety
        localStorage.setItem("webvi_authToken", token);
        localStorage.setItem("jobseekerspage_userId", userId);

        console.log(token, "Token Saved Successfully!");

        const redirect_url = localStorage.getItem(
          "jobseekerspage_redirect_url",
        );
        console.log("Redirect URL:", redirect_url);

        if (redirect_url) {
          localStorage.removeItem("jobseekerspage_redirect_url");
          console.log("NAVIGATING TO REDIRECT:", redirect_url);
          navigate(redirect_url);
          return;
        }

        // ✅ FIX: Use serverCustomerType instead of formData
        if (Number(serverCustomerType) === 1) {
          console.log("MATCH FOUND: Redirecting to Employer");
          navigate("/employer/dashboard");
        } else {
          console.log("MATCH NOT FOUND: Redirecting to Candidate");
          navigate("/candidate/dashboard");
        }
      } else {
        console.log("TOKEN NOT FOUND ❌");
        // CustomSnackbar.error("Login success but token missing!");
      }
    });
    // --- End of replacement ---
  };

  return (
    <>
      <VerifyEmailAndMobileModal
        openModal={openVerifyModal}
        setOpenModal={setOpenVerifyModal}
        formData={formData}
        userData={userData}
      />

      <Form onSubmit={onSubmit} className="auth-form">
        <div className="mb-3">
          <label htmlFor="usernameInput" className="form-label">
            Email or Mobile Number
          </label>
          <Input
            type="text"
            className="form-control"
            id="usernameInput"
            placeholder="Enter your email or mobile number"
            required
            name="email"
            onChange={(e) => onValueChange(e, "username")}
            value={formData?.username}
          />
        </div>

        <div className="mb-3">
          <PasswordInput
            label="Password"
            id="passwordInput"
            name="password"
            required={true}zz
            value={formData?.password}
            placeholder="Enter your password"
            onChange={(e) => onValueChange(e, "password")}
          />
        </div>
        <div className="mb-4">
          <div className="form-check">
            <Link to="/resetpassword" className="float-end text-white">
              Forgot Password?
            </Link>
          </div>
        </div>
        <div className="text-center">
          {isLoading ? (
            <button
              className="btn btn-white btn-hover w-100 disabled"
              type="button"
            >
              Sign In <Spinner size="sm" />
            </button>
          ) : (
            <button className="btn btn-white btn-hover w-100" type="submit">
              Sign In
            </button>
          )}
        </div>
      </Form>
    </>
  );
};

export default SignInForm;
